module.exports = __webpack_public_path__ + "img/svg/pizza-stats.8a9fbc8c52b1a900f28e71dd9697f760.svg";